import { useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router.js';
import { queryClient } from './lib/query-client.js';
import { bootSession } from './lib/api.js';
import { OfflineNotice } from './components/pwa/OfflineNotice.js';
import { InstallPrompt } from './components/pwa/InstallPrompt.js';
import { UpdatePrompt } from './components/pwa/UpdatePrompt.js';

export function App() {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    bootSession().finally(() => setBooted(true));
  }, []);

  if (!booted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="flex items-center gap-3 text-muted">
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-navy/20 border-r-navy" />
          <span className="text-sm">Starting Admitly…</span>
        </div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <OfflineNotice />
      <RouterProvider router={router} />
      <InstallPrompt />
      <UpdatePrompt />
    </QueryClientProvider>
  );
}
